export * from './customer';
export * from './doctor';
export * from './global-response';
export * from './pet';
export * from './clinic';
export * from './user';
export * from './upload-file';
